import { Component, Input } from '@angular/core';
import { SlimIntegrationApp, MarketplaceVisibility, IntegrationAppInstallation_State } from '@proto/odoo/integrations';
import { IntegrationAppsService } from '../../integration-apps.service';

@Component({
  selector: 'app-integration-apps-card',
  templateUrl: './integration-apps-card.component.html',
  standalone: false
})
export class IntegrationAppsCardComponent {

  @Input() public integrationApp: SlimIntegrationApp;
  @Input() public installationState?: IntegrationAppInstallation_State;
  @Input() public isAlreadyInstalled?: boolean;
  @Input() public preselectedSubId?: string;
  @Input() public preselectedSubName?: string;

  protected readonly MarketplaceVisibility = MarketplaceVisibility;

  constructor(public integrationService: IntegrationAppsService) {}

}
